import { render, staticRenderFns } from "./Trays.vue?vue&type=template&id=284735e6&"
import script from "./Trays.vue?vue&type=script&lang=js&"
export * from "./Trays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('284735e6')) {
      api.createRecord('284735e6', component.options)
    } else {
      api.reload('284735e6', component.options)
    }
    module.hot.accept("./Trays.vue?vue&type=template&id=284735e6&", function () {
      api.rerender('284735e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/vistas/Trays.vue"
export default component.exports